export default __webpack_public_path__ + "b8391ca994f9024f837fdcfeda37a9d1.jpg";